import { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import clsx from "clsx";
import { MouseEvent, ReactNode } from "react";
import {
  StyledIconContainer,
  StyledLoadingContainer,
  StyledPrimaryButton,
} from "./styled";

export type PrimaryButtonProps = {
  color?: "primary" | "error" | "secondary";
  title: string | ReactNode;
  flex?: boolean;
  loading?: boolean;
  onClick?: (e: MouseEvent) => void;
  className?: string;
  variant?: "outlined" | "contained" | "text" | "text-no-effect" | "shadow";
  size?: "medium" | "small";
  rounded?: boolean;
  disabled?: boolean;
  icon?: ReactNode;
  leftSideIcon?: boolean;
  buttonProps?: ButtonProps;
};

const PrimaryButton = ({
  title,
  flex,
  onClick,
  color = "primary",
  disabled,
  variant = "contained",
  size = "medium",
  rounded = true,
  className,
  icon,
  buttonProps,
  loading,
  leftSideIcon,
}: PrimaryButtonProps) => {
  const renderLoading = () => (
    <StyledLoadingContainer>
      <CircularProgress className="loading" size={16} />
    </StyledLoadingContainer>
  );

  const renderButtonContent = () => (
    <>
      {icon && leftSideIcon && (
        <StyledIconContainer className="left">{icon}</StyledIconContainer>
      )}
      {title}
      {icon && !leftSideIcon && (
        <StyledIconContainer>{icon}</StyledIconContainer>
      )}
    </>
  );

  return (
    <StyledPrimaryButton
      className={clsx(
        "data-qa-primary-button",
        variant,
        size,
        color,
        {
          loading,
          flex,
          rounded,
        },
        className,
      )}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      disabled={disabled || loading}
      disableRipple={variant === "text-no-effect"}
      {...buttonProps}
    >
      {loading ? renderLoading() : renderButtonContent()}
    </StyledPrimaryButton>
  );
};

export default PrimaryButton;
